import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormSchema } from '../utils/types/form'
import { SubmissionSchema } from '../utils/types/submission'
import SVG from '../assets/undraw_welcoming_42an.svg'

export const ConfirmResponseView: React.FC<{
  form: FormSchema | null
  submission: SubmissionSchema
}> = (props) => {
  const { form, submission } = props

  const [isHovering, setIsHovering] = useState(false)

  const navigate = useNavigate()

  return (
    <div className='main_content experience_content experience_content-alt'>
      <div>
        <h1 className='heading-styled'>Response submitted...</h1>
        <p>
          Your submission for <em>{form?.name}</em> was successful.{' '}
          <span
            className='span-a'
            onClick={() =>
              navigate(`/form/${submission.formId}/submission/${submission._id}`, {
                viewTransition: true
              })
            }>
            Click here
          </span>{' '}
          to view.
        </p>
      </div>
      <div className='svg_container'>
        <img src={SVG} alt='No results' className='img-lg' />
        <button
          className='button-with-icon cta'
          onClick={() => navigate('/experience?ctx=submit', { viewTransition: true })}
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}>
          <span>Welcome to Springforms!</span>
          <span className='material-symbols-rounded material-symbols-pd'>
            {isHovering ? 'sentiment_excited' : 'sentiment_very_satisfied'}
          </span>
        </button>
      </div>
    </div>
  )
}
